// extracted by mini-css-extract-plugin
module.exports = {"container":"IlMioSaldoListItem_container__xZ15H","pseudoElement":"IlMioSaldoListItem_pseudoElement__w3b6J"};